/**
 * This class provides fuctionality to use bit enums as masks.
 */
export class Bitflag<T extends number>{
    private mask: number = 0;
    /**
     * 
     * @param mask Initial value of the mask.
     */
    constructor(mask?: T){
        if(mask)
            this.mask = mask   
    }

    /**
     * Sets the mask to the given mask value
     * @param flag 
     */
    set(flag: T){
        this.mask = flag;
    }

    /**
     * Returns true if the flag is set to '1'. 
     * @param flag Multiple flags can be polled using the bitwise OR operator '|'
     * @returns True if the given flag(s) were set.
     */
    hasFlag(flag: T){
        return ((this.mask & flag)===flag);
    }

    /**
     * Sets the given flag(s) to '1'.
     * @param flag Multiple flags can be set using the bitwise OR operator '|'
     */
    addFlag(flag: T){
        this.mask |= flag;
    }

    /**
     * Sets the given flag(s) to '0'.
     * @param flag Multiple flags can be set using the bitwise OR operator '|'
     */
    removeFlag(flag: T){
        this.mask &= ~flag;
    }

    /**
     * Toggles the given flag(s) from '0' to '1' or from '1' to '0'.
     * @param flag Multiple flags can be set using the bitwise OR operator '|'
     */
    toggleFlag(flag: T){
        this.mask ^= flag;
    }

    /**
     * Sets all flags to '0'
     */
    clear(){
        this.mask = 0
    }

    /**
     * Sets all flags to '1'.
     */
    enableAll(){
        this.mask = -1;
    }

    /**
     * Checks whether all flags are disabled
     * @returns True if all flags are set to '0'
     */
    allDisabled(){
        return this.mask === 0;
    }

    /**
     * Check whether all flags are enabled.
     * @returns True if all flags are set to '1'
     */
    allEnabled(){
        return ((this.mask & -1)>0);
    }
}